import { isSvgIconStrictSize } from './isSvgIconStrictSize';
// TODO: to delete legacy function
// export const getIconSize = (size: SvgIconProps['size'], pxToRem: (pixel: number) => string) =>
// 	size === '3xs'
// 		? pxToRem(12)
// 		: size == '2xs'
// 		? pxToRem(13)
// 		: size === 'xs'
// 		? pxToRem(14)
// 		: size === 'sm'
// 		? pxToRem(15)
// 		: size === 'md'
// 		? pxToRem(16)
// 		: size === 'lg'
// 		? pxToRem(17)
// 		: size === 'xl'
// 		? pxToRem(18)
// 		: size === '2xl'
// 		? pxToRem(19)
// 		: size === '3xl'
// 		? pxToRem(20)
// 		: size === '4xl'
// 		? pxToRem(22)
// 		: size;
export function getIconSize(size, pxToRem) {
    if (isSvgIconStrictSize(size)) {
        switch (size) {
            case '3xs':
                return pxToRem(12);
            case '2xs':
                return pxToRem(13);
            case 'xs':
                return pxToRem(14);
            case 'sm':
                return pxToRem(15);
            case 'md':
                return pxToRem(16);
            case 'lg':
                return pxToRem(17);
            case 'xl':
                return pxToRem(18);
            case '2xl':
                return pxToRem(19);
            case '3xl':
                return pxToRem(20);
            case '4xl':
                return pxToRem(22);
            default:
                throw new Error(`Unhandled SvgIconSize case: ${size}`);
        }
    }
    return size;
}
